import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { confirmDialog } from 'primereact/confirmdialog';

interface ImageThumbnailCardProps {
  imageUrl: string;
  index: number;
  onDelete: () => void;
  onClick: () => void;
  isDeleting?: boolean;
}

const ImageThumbnailCard: React.FC<ImageThumbnailCardProps> = ({ 
  imageUrl, 
  index, 
  onDelete, 
  onClick, 
  isDeleting 
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    confirmDialog({
      message: 'Are you sure you want to delete this image?',
      header: 'Confirm Delete',
      icon: 'pi pi-exclamation-triangle',
      accept: onDelete,
      acceptClassName: 'p-button-danger'
    });
  };

  return (
    <div 
      className="relative border-round overflow-hidden cursor-pointer transition-all duration-200 hover:shadow-lg transform hover:scale-105"
      style={{ 
        backgroundColor: '#f8f9fa',
        width: '100%',
        height: 'auto',
        minHeight: '150px' // Minimum height for consistency
      }}
      onClick={onClick}
    >
      {/* Delete button */}
      <Button
        icon="pi pi-times"
        className="absolute top-1 right-1 z-2"
        size="small"
        severity="danger"
        rounded
        onClick={handleDelete}
        disabled={isDeleting}
        style={{ width: '1.5rem', height: '1.5rem', fontSize: '0.7rem' }}
      />
      
      {/* Loading spinner overlay */}
      {isDeleting && (
        <div className="absolute inset-0 bg-black bg-opacity-50 flex align-items-center justify-content-center z-1">
          <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="4" />
        </div>
      )}

      {/* Image loading spinner */}
      {!imageLoaded && (
        <div className="absolute inset-0 flex align-items-center justify-content-center">
          <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="4" />
        </div>
      )}

      {/* Actual image */}
      <img
        src={imageUrl}
        alt={`Product image ${index + 1}`}
        className={`w-full h-auto object-contain transition-opacity duration-200 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
        onLoad={() => setImageLoaded(true)}
        onError={() => setImageLoaded(true)}
        style={{ 
          objectFit: 'contain',
          maxWidth: '100%',
          height: 'auto'
        }}
      />
    </div>
  );
};

export default ImageThumbnailCard;